import React from 'react'
import { Button, Div, Text } from '@sendoutcards/quantum-design-ui'
import { FlexColumn, FlexRow } from 'src/styled'
import { useSelector } from 'src/hooks'

const AffiliateSuccess = (props: { onClose: () => void }) => {
  const { onClose } = props
  const { isMobile } = useSelector(s => s.window)

  return (
    <Div style={{ width: '100%' }}>
      <FlexColumn
        style={{
          justifyContent: 'center',
          marginBottom: isMobile ? '65px' : undefined,
        }}
      >
        <Text type="heroTitle">Success!</Text>
        <Text type="body">You’ve set up your Affiliate account.</Text>
        <FlexRow style={{ justifyContent: 'flex-end' }}>
          <Button onClick={onClose} title="Close" type="primary" />
        </FlexRow>
      </FlexColumn>
    </Div>
  )
}

export default AffiliateSuccess
